import script from "./shatterC.vue?vue&type=script&setup=true&lang=js"
export * from "./shatterC.vue?vue&type=script&setup=true&lang=js"

import "./shatterC.vue?vue&type=style&index=0&id=b522f538&lang=css"

const __exports__ = script;

export default __exports__